<template>
  <div>
    <ul class="flex flex-rox flex-wrap">
      <li class="tab-button" :class="{active: isActive(index)}" @click="select(index)" v-for="(tab, index) in tabList" :key="index">{{ tab.title }}</li>
    </ul>
    <div class="mt-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabsContainer',
  data () {
    return {
      tabList: [],
      activeTabIndex: 0
    }
  },
  mounted () {
    this.select(0)
    this.activeTabIndex = this.getInitialActiveTab()
    this.$root.$on('select-tab', index => this.select(index))
  },
  methods: {
    isActive (index) {
      return this.activeTabIndex === index
    },
    select (index) {
      const tab = this.tabList[index]
      if (!tab.isDisabled) {
        this.activeTabIndex = index
      }
      this.$emit('changed', tab)
    },
    getInitialActiveTab () {
      const index = this.tabList.findIndex(tab => tab.active)
      return index === -1 ? 0 : index
    }
  }
}

</script>

<style scoped>
.tab-button {
  @apply px-4 py-2 border-2 font-bold border-black cursor-pointer transition-all duration-1000;
  border-collapse: collapse;
}
.active {
  @apply bg-black text-white;
}
</style>
